import { useState } from 'react'
import { Trash2 } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { useToast } from '@/providers/UiProviders'
import { clearCache, DT_STR as S } from './devtoolsApi'

const SCOPES: { id: string; label: string }[] = [
  { id: 'all', label: S.scopeAll },
  { id: 'users', label: S.scopeUsers },
  { id: 'config', label: S.scopeConfig },
]

/**
 * A27.11 — Очистка кэша. FUNCTIONAL: one button per scope → the real
 * `POST /admin/devtools/cache/clear {scope}` (config/all invalidate the live
 * settings cache). No button-level gate; the endpoint enforces access.
 */
export function CacheScreen() {
  const { toast } = useToast()
  const [busy, setBusy] = useState<string | null>(null)

  const clear = async (scope: string) => {
    setBusy(scope)
    try {
      await clearCache(scope)
      toast(S.cleared, { tone: 'success' })
    } catch {
      toast(S.failed, { tone: 'error' })
    } finally {
      setBusy(null)
    }
  }

  return (
    <>
      <PageHeader title={S.cache} screenId="A27.11" />
      <div className="grid max-w-2xl grid-cols-1 gap-3 p-4 sm:grid-cols-3">
        {SCOPES.map((sc) => (
          <button
            key={sc.id}
            type="button"
            onClick={() => clear(sc.id)}
            disabled={busy !== null}
            className="flex flex-col items-start gap-2 rounded-md border border-border-default bg-surface-1 p-4 text-left hover:border-border-strong disabled:opacity-50"
          >
            <Trash2 size={18} className="text-secondary" />
            <span className="text-sm font-medium text-primary">{sc.label}</span>
            <span className="text-xs text-secondary">
              {busy === sc.id ? S.running : S.clear}
            </span>
          </button>
        ))}
      </div>
    </>
  )
}
